import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';

export default function GatewayUK() {
  return (
    <>
      <SEO
        title="Fastlane ApS :: The gateway to/from UK/Scandinavia"
        description="The gateway to/from UK/Scandinavia. Fastlane arranges palletized goods, 48 hours service, driver accompanied trailers and warehousing."
        canonicalUrl="https://fastlane.dk/gateway-tofrom-ukscandinavia"
      />

      <PageHeader
        title="The gateway to/from UK/Scandinavia"
        subtitle="Reliable freight forwarding and haulage between the United Kingdom and Scandinavia."
        breadcrumbs={[
          { label: 'Services', path: '/godstransport-i-europa' },
          { label: 'UK & Scandinavia' }
        ]}
      />

      <div className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          <div className="bg-slate-50 p-6 sm:p-8 rounded-2xl border border-slate-200/90 space-y-4">
            <h2 className="text-xl sm:text-2xl font-bold text-[#0f2b48]">Key Capabilities:</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-slate-800">
              {[
                'Palletized goods',
                '48 hours service',
                'Driver accompanied trailers, loose trailers or pallet wide containers',
                'Abnormal loads',
                'Hazardous goods',
                'Parcels',
                'Business to Business or Private Individuals',
                'Warehousing',
                'Pick and pack'
              ].map((item, idx) => (
                <div key={idx} className="flex items-center gap-2.5 p-3 rounded-lg bg-white border border-slate-200">
                  <i className="fa-solid fa-circle-check text-sky-600 text-xs shrink-0" aria-hidden="true" />
                  <span className="font-medium">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-4 text-slate-700 leading-relaxed text-base sm:text-lg">
            <p>
              You are always welcome to e-mail us (<a href="mailto:booking@fastlane.dk" className="text-sky-700 font-semibold underline">booking@fastlane.dk</a>), call us (<a href="tel:+4576121230" className="text-[#0f2b48] font-bold whitespace-nowrap">+45 76 12 12 30</a>) or submit an inquiry.
            </p>
          </div>

          <div className="pt-4 flex flex-col sm:flex-row gap-3 sm:gap-4 sm:items-center sm:justify-between border-t border-slate-200">
            <span className="text-sm text-slate-600">Request a quote for UK transport:</span>
            <Link
              to="/fragtrater"
              className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-2.5 rounded-lg bg-[#b25d19] text-white text-sm font-semibold hover:bg-[#974d12] text-center"
            >
              Submit an inquiry
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
